<mat-accordion displayMode="flat">
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="isExpanded" (opened)="isExpanded=true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon>assessment</mat-icon>
        <span>{{ 'EPM.LAYOUT.FILTERS' | translate }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <form [formGroup]="taskFilterForm"
            (ngSubmit)="onFiltersFormSubmit()"
            fxLayout="column" fxLayoutGap="10px">
        <!-- <div>
          <mat-form-field fxFlex floatLabel="always">
            <mat-label>{{ 'EPM.LABELS.PROCESS_DEFINITION_KEY' | translate }}</mat-label>
            <mat-select
              formControlName="processDefinitionKey"
              style="line-height: initial"
              placeholder="{{ 'EPM.FORM.OPTION.SELECT_OPTION' | translate }}">
              <mat-option *ngFor="let processDef of processDefs"
                          [value]="processDef.name">
                {{ processDef.title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
        <!-- Plan-aligned order and labels -->
        <div>
          <mat-form-field fxFlex>
            <mat-label>{{ 'EPM.PROCESS_LIST.FILTERS.SITE_ID' | translate }}</mat-label>
            <mat-select formControlName="site" style="line-height: initial">
              <mat-option [value]="''">{{ 'EPM.FORM.OPTION.SELECT_OPTION' | translate }}</mat-option>
              <mat-option *ngFor="let site of sites" [value]="site.id">{{ site.title }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field fxFlex>
            <mat-label>{{ 'EPM.FORM.PLAN' | translate }}</mat-label>
            <mat-select formControlName="plan" style="line-height: initial" [disabled]="!filterSite.value || !(plans?.length)">
              <mat-option [value]="''">{{ 'EPM.FORM.OPTION.SELECT_OPTION' | translate }}</mat-option>
              <mat-option *ngFor="let plan of plans" [value]="plan.nodeRef">{{ plan.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <mat-divider></mat-divider>
        <div>
          <mat-form-field fxFlex style="margin-top: 1em">
            <mat-label>{{ 'EPM.LABELS.STATUS' | translate }}</mat-label>
            <mat-select formControlName="status" style="line-height: initial">
              <mat-option [value]="'completed'">{{ 'EPM.FORM.TASK_STATUS.COMPLETED' | translate }}</mat-option>
              <mat-option [value]="'active'">{{ 'EPM.FORM.TASK_STATUS.ACTIVE' | translate }}</mat-option>
              <mat-option [value]="'draft'">{{ 'EPM.FORM.TASK_STATUS.DRAFT' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-label style="font-size: 12px; color: rgba(0, 0, 0, 0.6); display: block; margin-bottom: 4px;">{{ 'EPM.LABELS.TYPE' | translate }}</mat-label>
          <div *ngFor="let ctrl of typesFormArray.controls; let i = index">
            <mat-form-field fxFlex style="margin-bottom: 0px;">
              <mat-select [formControl]="getTypeControl(i)" style="line-height: initial" [disabled]="!filterSite.value || !(types?.length)">
                <!-- <mat-option [value]="''">{{ 'EPM.FORM.OPTION.SELECT_OPTION' | translate }}</mat-option> -->
                <mat-option *ngIf="i === 0" [value]="'any'">{{ 'EPM.FORM.TYPE.ANY' | translate }}</mat-option>
                <mat-option *ngFor="let type of getAvailableTypes(i)" [value]="type.ref">{{ type.name }}</mat-option>
              </mat-select>
              <button *ngIf="typesFormArray.length > 1" matSuffix mat-icon-button aria-label="Remove" (click)="removeTypeField(i)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div>
          <mat-form-field fxFlex>
            <mat-label>{{ 'EPM.LABELS.HANDOVER' | translate }}</mat-label>
            <mat-select formControlName="handover" style="line-height: initial" [disabled]="!filterSite.value || !(handovers?.length)">
              <mat-option [value]="''">{{ 'EPM.FORM.OPTION.SELECT_OPTION' | translate }}</mat-option>
              <ng-container *ngIf="handovers?.length">
                <mat-option *ngFor="let ho of handovers" [value]="ho">{{ ho }}</mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <!-- <div>
          <mat-form-field fxFlex>
            <mat-label>{{ 'EPM.LABELS.PRIORITY' | translate }}</mat-label>
            <mat-select
              formControlName="priority"
              style="line-height: initial">
              <mat-option>{{ 'EPM.FORM.OPTION.SELECT_OPTION' | translate }}</mat-option>
              <mat-option [value]="1">{{ 'EPM.FORM.PRIORITY.1' | translate }}</mat-option>
              <mat-option [value]="2">{{ 'EPM.FORM.PRIORITY.2' | translate }}</mat-option>
              <mat-option [value]="3">{{ 'EPM.FORM.PRIORITY.3' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
        
        <div>
          <mat-form-field fxFlex>
            <mat-label>{{ 'EPM.LABELS.STARTED_AFTER' | translate }}</mat-label>
            <input [max]="currentDate"
                   matInput [matDatepicker]="taskStartedAfterDatePicker"
                   formControlName="startedAfter">
            <mat-hint>{{getDateFormatString()}}</mat-hint>
            <mat-datepicker-toggle
              matSuffix
              [for]="taskStartedAfterDatePicker">
            </mat-datepicker-toggle>
            <mat-datepicker
              #taskStartedAfterDatePicker
              [touchUi]="tasksDataService.isSmallScreen">
            </mat-datepicker>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field fxFlex>
            <mat-label>{{ 'EPM.LABELS.STARTED_BEFORE' | translate }}</mat-label>
            <input
              matInput [matDatepicker]="taskStartedBeforeDatePicker"
              formControlName="startedBefore">
            <mat-hint>{{getDateFormatString()}}</mat-hint>
            <mat-datepicker-toggle
              matSuffix
              [for]="taskStartedBeforeDatePicker">
            </mat-datepicker-toggle>
            <mat-datepicker
              #taskStartedBeforeDatePicker
              [touchUi]="tasksDataService.isSmallScreen">
            </mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxLayoutGap="20px" fxLayoutGap.lt-md="0px">
          <mat-form-field fxFlex (click)="isAssigneeSearchOpen=!isAssigneeSearchOpen">
            <mat-label>{{ 'EPM.LABELS.ASSIGNEE' | translate }}</mat-label>
            <input
                   readonly
                   matInput
                   formControlName="assignee">
            <button *ngIf="filterAssignee.value" matSuffix mat-icon-button aria-label="Clear" (click)="filterAssignee.setValue('')">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <epm-people-search [showPeopleSearch]="isAssigneeSearchOpen" class="people-search-field"
                             (userSelect)="onAssigneeSelect($event)">
          </epm-people-search>
        </div>
        <div class="epm-filter-actions" align="end">
          <button mat-raised-button type="button" (click)="resetForm()">{{ 'EPM.FORM.BUTTON.RESET' | translate }}</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!taskFilterForm.valid">{{ 'EPM.PROCESS_LIST.FILTERS.SUBMIT' | translate }}</button>
        </div>
      </form>
    </div>
  </mat-expansion-panel>
</mat-accordion>

